import React, { useEffect } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import ChatList from "./components/ChatList";
import Header from "./components/Header";
import { useAuthState } from "react-firebase-hooks/auth";
import { auth, db } from "./firebase";
import Login from "./Login";
import Loading from "./components/Loading";
import firebase from "firebase";
import ChatScreen from "./components/ChatScreen";

function App() {
  const [user, loading] = useAuthState(auth);

  useEffect(() => {
    if (user) {
      db.collection("users").doc(user.uid).set(
        {
          email: user.email,
          displayName: user.displayName,
          lastSeen: firebase.firestore.FieldValue.serverTimestamp(),
          photoURL: user.photoURL,
        },
        { merge: true }
      );
    }
  }, [user]);

  if (loading) return <Loading />;
  if (!user) return <Login />;

  return (
    <Router>
      <Header />
      <Switch>
        <Route exact path="/">
          <ChatList />
        </Route>
        <Route path="/chat/:id/:mail" children={<ChatScreen />} />
      </Switch>
    </Router>
  );
}

export default App;
